export default {
    VERSION: "Версия"
};
